import type { Messages } from './en';

/** 輪流出現的 NPC 閒聊（繁體中文・台灣）。 */
export const zhTWTalks: Messages['talks'] = {
  chat: '💬 聊天',
  emma: {
    greet: {
      morning: ['早安！昨天睡得好嗎？', '早～我今天帶了草莓牛奶喔！'],
      afternoon: ['嘿！今天上課還好嗎？', '嗨！今天下午天氣好好喔！'],
      evening: ['啊，嗨！我等一下要回家了。', '今天的夕陽好漂亮！'],
    },
    topics: [
      {
        say: '我在學一首新的英文歌。你喜歡音樂嗎？',
        choices: [
          { t: '超喜歡！唱給我聽好不好？', reply: '好啦，只唱副歌喔……啦啦啦！哈哈，不准笑！' },
          { t: '那首歌在唱什麼？', reply: '在說就算覺得自己很渺小，也要勇敢。我好喜歡這個意思。' },
          { t: '妳要邊唱邊跳我才聽！', reply: '哈哈！好啊，可是你要陪我一起跳！' },
        ],
      },
      {
        say: '如果可以去任何地方旅行，你想去哪裡？',
        choices: [
          { t: '只要跟妳和大家一起就好！', reply: '哇～這是最棒的答案！那就來辦班遊吧！' },
          { t: '那妳想去哪裡？', reply: '京都，去看寺廟！或是阿爾卑斯山，去看雪！' },
          { t: '月球啊，這還用問。', reply: '哈哈！記得帶零食，帶超多零食。' },
        ],
      },
      {
        say: '我這次數學考得比預期的還差……',
        choices: [
          { t: '妳很努力了，這才是最重要的。', reply: '謝謝……你說得對。我會去問老師我錯的地方。' },
          { t: '哪裡比較難？我們可以一起讀。', reply: '分數！唉。好，那我們約圖書館一起讀書？' },
          { t: '數學只是一群很愛演的數字啦。', reply: '哈哈哈！說真的，我心情好多了。' },
        ],
      },
      {
        say: '我家貓咪今天早上把我的作業從桌上撥下去了。',
        choices: [
          { t: '天啊！作業還好嗎？', reply: '有點皺，但還好。不過我家貓咪一臉超得意的。' },
          { t: '妳的貓叫什麼名字？', reply: '布丁！牠是橘色的，而且圓滾滾的。' },
          { t: '牠是想幫妳寫作業吧。', reply: '哈哈，可是牠的英文超爛的。' },
        ],
      },
    ],
  },
  rain: {
    greet: {
      morning: ['早安！我已經讀到第五章了。', '嗨！要不要借一本書？'],
      afternoon: ['噓，圖書館要小聲！嗨！', '啊，是你！來得正好。'],
      evening: ['我又看書看到這麼晚了。', '再一頁就好……好啦，再十頁。'],
    },
    topics: [
      {
        say: '我在看一本推理小說，我覺得我知道兇手是誰了！',
        choices: [
          { t: '不要爆雷！我也想看。', reply: '我嘴巴拉上拉鍊了。看完借你。' },
          { t: '妳找到什麼線索？', reply: '一隻沾滿泥巴的鞋子，還有一把不見的雨傘。超可疑的。' },
          { t: '是管家啦，兇手一定是管家。', reply: '哈哈！這個故事裡根本沒有管家！' },
        ],
      },
      {
        say: '有時候我在課堂上發言會很緊張。',
        choices: [
          { t: '很多人都會，妳不是一個人。', reply: '真的嗎？這樣好多了。也許明天我會試著舉手一次。' },
          { t: '是什麼讓妳覺得可怕？', reply: '大家都盯著我看。不過跟你練習有幫助。' },
          { t: '把大家想像成馬鈴薯就好。', reply: '馬鈴薯……好啦，很蠢，但說不定有用！' },
        ],
      },
      {
        say: '你比較喜歡漫畫還是小說？',
        choices: [
          { t: '都喜歡！故事就是故事。', reply: '沒錯！好故事就是好故事。' },
          { t: '可以推薦我一本嗎？', reply: '試試《守燈人》，講一個女孩照顧燈塔的故事。' },
          { t: '食譜，我喜歡看圖片。', reply: '哈哈！害我肚子餓了。' },
        ],
      },
    ],
  },
  teacher: {
    greet: {
      morning: ['早安，準備好迎接今天了嗎？', '早！記得多喝水喔。'],
      afternoon: ['你好！最近上課還順利嗎？', '喔，你好。今天很忙嗎？'],
      evening: ['你還在學校啊？記得早點回家休息。', '今天辛苦了。'],
    },
    topics: [
      {
        say: '幫助別人很棒，但也要記得照顧好自己。',
        choices: [
          { t: '我會的，謝謝林老師。', reply: '很好。好好休息、好好吃飯，需要幫忙時要說出來。' },
          { t: '老師都怎麼照顧自己？', reply: '一杯茶、散個步、早點睡。簡單的事最有用。' },
          { t: '那我為了健康多吃一塊餅乾。', reply: '哈哈。一塊就好，再配一份水果。' },
        ],
      },
      {
        say: '八年三班在籌備義賣，你有什麼點子嗎？',
        choices: [
          { t: '手工餅乾！我會烤。', reply: '好點子。手作點心大家都很捧場。' },
          { t: '義賣的錢要用在哪裡？', reply: '幫兒童醫院買書。很有意義吧？' },
          { t: '來辦「把老師丟進水池」？', reply: '絕對不行。不過你很會想喔。' },
        ],
      },
      {
        say: '這週的閱讀作業讀完了嗎？',
        choices: [
          { t: '讀完了！我喜歡那個結局。', reply: '我也是。我們上課再來討論。' },
          { t: '還沒，很長嗎？', reply: '二十頁。每天讀一點，這就是訣竅。' },
          { t: '被我家貓吃掉了。', reply: '嗯，傳說中會吃作業的貓。我聽說過。' },
        ],
      },
    ],
  },
  chunbo: {
    greet: {
      morning: ['早啊，小朋友！', '這麼早就來啦？很好很好。'],
      afternoon: ['午安！沒在調皮吧？', '今天很熱吼？'],
      evening: ['要回家啦？過馬路小心車。', '又過了一天，辛苦啦。'],
    },
    topics: [
      {
        say: '我像你這麼大的時候，每天要走一個小時去上學。',
        choices: [
          { t: '哇，好厲害！', reply: '而且我很喜歡喔！每天早上都看得到稻田跟水牛。' },
          { t: '那時候的學校是什麼樣子？', reply: '很小。一間教室、一個老師，吵得不得了。' },
          { t: '來回都是上坡嗎？', reply: '哈哈！你這孩子真聰明。只有去的時候，回家是下坡！' },
        ],
      },
      {
        say: '我在警衛室後面種了一個小菜園。',
        choices: [
          { t: '我可以找時間幫忙澆水嗎？', reply: '當然好！番茄喜歡有人陪。' },
          { t: '您種了什麼？', reply: '番茄、九層塔，還有一顆很固執的南瓜。' },
          { t: '那些植物也會幫忙顧門嗎？', reply: '哈哈！南瓜是我的副手。' },
        ],
      },
      {
        say: '記住：如果有陌生人要帶你去哪裡，就說不要，然後來找我。',
        choices: [
          { t: '我會的，春伯。', reply: '很好。安全永遠第一。' },
          { t: '如果他說認識我媽媽呢？', reply: '還是要說不要。你家人不會沒告訴你就叫陌生人來接你。' },
          { t: '我會擺個空手道姿勢再逃跑。', reply: '逃跑那段就夠了啦！' },
        ],
      },
    ],
  },
  librarian: {
    greet: {
      morning: ['早安，孩子。', '啊，一大早就來看書的小讀者！'],
      afternoon: ['你好。在找什麼特別的書嗎？', '歡迎回來。'],
      evening: ['快要閉館了，不過慢慢來沒關係。', '今天最後的借書機會囉！'],
    },
    topics: [
      {
        say: '每一本書都是通往另一個世界的門。',
        choices: [
          { t: '我下一扇該開哪一扇門？', reply: '試試看關於海洋的書吧，你看魚的眼光會完全不同。' },
          { t: '王阿姨第一本最愛的書是什麼？', reply: '一本講勇敢小老鼠的書。我讀了三十遍呢。' },
          { t: '有沒有關於門的書？', reply: '哈！其實……還真的有。建築類，第十二排書架。' },
        ],
      },
      {
        say: '舊書要輕輕翻喔，它們比我還老呢！',
        choices: [
          { t: '我會小心的，我保證。', reply: '謝謝你。書會記得誰溫柔對待它們。' },
          { t: '最老的一本有多老？', reply: '超過八十年了！是一本紙很薄很薄的字典。' },
          { t: '比您還老？不可能啦！', reply: '哎喲，你這孩子嘴真甜。快去看書吧！' },
        ],
      },
    ],
  },
  coach: {
    greet: {
      morning: ['早！先拉筋！', '起床囉，冠軍！'],
      afternoon: ['嘿！要不要跑一圈？', '保持這股活力！'],
      evening: ['先緩和一下，再回家。', '今天表現很努力！'],
    },
    topics: [
      {
        say: '運動不是為了贏，而是每天進步一點點。',
        choices: [
          { t: '我每天都會盡力的。', reply: '就是這個精神！小步前進，大大收穫。' },
          { t: '要怎麼跑得更快？', reply: '睡飽、吃好、多練起跑。從起跑線爆發出去！' },
          { t: '我可以練習把午睡睡得更好嗎？', reply: '哈！休息也是訓練的一部分。不過要練完再睡。' },
        ],
      },
      {
        say: '還沒口渴就要喝水，身體會感謝你的。',
        choices: [
          { t: '知道了，教練！', reply: '很好。補充水分就是超能力。' },
          { t: '要喝多少才夠？', reply: '活動的時候，大概每小時喝一杯。' },
          { t: '珍奶算嗎？', reply: '想得美。先喝水！' },
        ],
      },
    ],
  },
  clerk: {
    greet: {
      morning: ['早安！今天有新鮮麵包喔。', '嗨！這麼早來買東西？'],
      afternoon: ['歡迎光臨！需要幫忙嗎？', '又見面啦！'],
      evening: ['晚安！飯糰現在半價喔。', '今天很累嗎？買個點心吧。'],
    },
    topics: [
      {
        say: '你知道這家店開到晚上十一點嗎？',
        choices: [
          { t: '好長的班！謝謝你這麼辛苦。', reply: '哎，謝啦。有你這樣的客人，上班都變輕鬆了。' },
          { t: '最受歡迎的是什麼？', reply: '茶葉蛋！每天都賣出好幾十顆。' },
          { t: '你都睡在櫃檯後面嗎？', reply: '哈哈，只有在夢裡啦！' },
        ],
      },
      {
        say: '我在存錢，希望有一天能開自己的咖啡店。',
        choices: [
          { t: '你一定做得到！我要當第一個客人。', reply: '一言為定！第一杯可可我請客。' },
          { t: '你想取什麼店名？', reply: '「小燈籠咖啡館」。很溫馨，擺滿植物。' },
          { t: '會有免費餅乾嗎？', reply: '給我的第一位客人？那當然！' },
        ],
      },
    ],
  },
  grandma: {
    greet: {
      morning: ['早安啊，乖孩子。', '今天早上空氣好清新，對不對？'],
      afternoon: ['來，陪奶奶坐一下。', '今天的鴿子特別餓呢。'],
      evening: ['差不多該回家囉。', '你看，天空好粉紅。'],
    },
    topics: [
      {
        say: '奶奶年輕的時候，這座公園整片都是稻田。',
        choices: [
          { t: '那一定很漂亮。', reply: '是啊。放眼望去一片綠，晚上還有青蛙在唱歌。' },
          { t: '那時候你們都玩什麼？', reply: '我們會把螢火蟲抓進玻璃罐，再把牠們放走。' },
          { t: '鴿子那時候也住這裡嗎？', reply: '哈！可能是牠們的曾曾祖父母吧！' },
        ],
      },
      {
        say: '你常常打電話給爺爺奶奶嗎？',
        choices: [
          { t: '我應該多打的，我會的！', reply: '他們一定會很開心。短短一通電話就很有意義了。' },
          { t: '爺爺奶奶喜歡聽什麼？', reply: '你吃了什麼、學了什麼，還有你過得開不開心。' },
          { t: '我都傳貼圖給他們！', reply: '貼圖很好，但聽到你的聲音更好。' },
        ],
      },
    ],
  },
  bo: {
    greet: {
      morning: ['嗨！要不要一起玩？', '你看！我撿到一顆亮晶晶的石頭！'],
      afternoon: ['抓到你了！換你當鬼！……開玩笑的。', '我是恐龍！吼～！'],
      evening: ['媽媽說我等一下就要回家了……', '我才不睏！＊打哈欠＊'],
    },
    topics: [
      {
        say: '我長大以後要當太空人！',
        choices: [
          { t: '你一定會是很棒的太空人！', reply: '對啊！我會從月球跟你揮手！' },
          { t: '你在太空要做什麼？', reply: '飄來飄去！還要吃太空冰淇淋！' },
          { t: '可以帶我一起去嗎？', reply: '你要帶零食才可以！' },
        ],
      },
      {
        say: '你會講笑話嗎？',
        choices: [
          { t: '什麼動物最愛問為什麼？……豬！因為「為什麼」都要「問豬」！', reply: '哈哈哈！我聽不懂，可是好好笑！' },
          { t: '那你會講嗎？', reply: '什麼東西有四隻腳又會「哈啾」？……感冒的牛！哈哈哈！' },
          { t: '叩叩叩。', reply: '是誰？……等一下，我也要玩！' },
        ],
      },
    ],
  },
  mom: {
    greet: {
      morning: ['早安，寶貝。早餐準備好囉。', '早！東西都帶齊了嗎？'],
      afternoon: ['嗨，寶貝，今天過得怎麼樣？', '你回來啦！先去洗手。'],
      evening: ['晚餐快好了喔。', '今天晚上不要太晚睡。'],
    },
    topics: [
      {
        say: '今天有沒有什麼辛苦的事，想跟媽媽聊聊？',
        choices: [
          { t: '有個朋友很難過，我試著幫他。', reply: '你好貼心。光是好好聽他說話，就是很大的幫助喔。' },
          { t: '媽媽，妳遇到難熬的日子都怎麼辦？', reply: '我會泡杯茶、深呼吸，然後提醒自己明天又是新的一天。' },
          { t: '最辛苦的是等晚餐。', reply: '哈哈！好啦好啦，快好了。' },
        ],
      },
      {
        say: '這個週末我們要煮什麼？',
        choices: [
          { t: '我們一起包水餃！', reply: '好啊！你負責包，我來做餡。' },
          { t: '可以教我妳的湯怎麼煮嗎？', reply: '當然。這是外婆教我的，現在換我教你。' },
          { t: '晚餐吃蛋糕？', reply: '蛋糕當甜點，晚餐要吃青菜！' },
        ],
      },
      {
        say: '看到你越來越有責任感，媽媽好驕傲。',
        choices: [
          { t: '謝謝媽媽，這是跟妳學的。', reply: '哎呀，你要害我哭了。過來抱一個！' },
          { t: '今天是什麼讓妳覺得驕傲？', reply: '你沒人提醒就主動幫忙。這對我意義很大。' },
          { t: '驕傲到可以多給零用錢嗎？', reply: '哈哈，想得美！驕傲是有，錢沒有。' },
        ],
      },
    ],
  },
  sister: {
    greet: {
      morning: ['起床！陪我玩！', '我畫了一隻貓！你看！'],
      afternoon: ['你回來了！耶！', '我們可以玩拼圖嗎？'],
      evening: ['講故事給我聽好不好？', '我才不想睡……＊打哈欠＊'],
    },
    topics: [
      {
        say: '月亮是不是一直跟著我們的車？',
        choices: [
          { t: '看起來是耶！它想跟妳打招呼。', reply: '月亮好！嘻嘻！' },
          { t: '因為它很遠很遠，所以看起來像在跟著我們。', reply: '喔……那它是不是同時跟著每一個人？' },
          { t: '對啊，它是一個很八卦的月亮。', reply: '八卦月亮！哈哈哈！' },
        ],
      },
      {
        say: '我做了一個有怪獸的惡夢。',
        choices: [
          { t: '我在這裡，妳很安全。', reply: '好……門可以留一點點縫嗎？' },
          { t: '那隻怪獸長什麼樣子？', reply: '又大又毛茸茸的……其實有點可愛。' },
          { t: '我用枕頭打敗牠！', reply: '枕頭大戰！枕頭大戰！' },
        ],
      },
    ],
  },
  dad: {
    greet: {
      morning: ['早啊，小冠軍。', '早安！先來杯咖啡。'],
      afternoon: ['嘿，你好啊！', '爸爸最喜歡的孩子今天好嗎？'],
      evening: ['呼，今天好累。來陪爸爸坐坐。', '今晚一起吃晚餐！'],
    },
    topics: [
      {
        say: '對不起，爸爸有時候工作到很晚。',
        choices: [
          { t: '沒關係，我喜歡我們一起吃飯的時候。', reply: '我也是。我會盡量多早點回家。' },
          { t: '你整天上班都在做什麼？', reply: '開很多會、做很多表格。沒有學校那麼精彩啦！' },
          { t: '你欠我一個遊戲之夜！', reply: '一言為定！星期六玩桌遊，不准滑手機。' },
        ],
      },
      {
        say: '要不要聽爸爸講個冷笑話？',
        choices: [
          { t: '講吧，爸。', reply: '什麼動物最容易摔倒？……狐狸，因為狡猾（腳滑）！' },
          { t: '要真的好笑才可以。', reply: '什麼東西越洗越髒？……水！哈哈，爸爸很聰明吧？' },
          { t: '拜託不要！', reply: '來不及了！什麼門永遠關不起來？……球門！' },
        ],
      },
    ],
  },
  xiaoyu: {
    greet: {
      morning: ['……嗨。', '喔。早。'],
      afternoon: ['嘿。', '嗨……剛才謝謝你。'],
      evening: ['我該回家了。', '今天還算可以。'],
    },
    topics: [
      {
        say: '我喜歡畫畫。腦袋很吵的時候，畫畫會有幫助。',
        choices: [
          { t: '這是讓自己好過一點的好方法。', reply: '嗯。也許哪天我會給你看我的畫。' },
          { t: '你喜歡畫什麼？', reply: '機器人。有時候也畫我家的狗。' },
          { t: '把我畫成超級英雄？', reply: '……好啊。哈哈。還要有披風。' },
        ],
      },
      {
        say: '你有沒有覺得對什麼都好累的時候？',
        choices: [
          { t: '有時候會。找人聊聊會有幫助。', reply: '嗯……跟你聊天有好一點。' },
          { t: '是什麼讓你覺得累？', reply: '家裡很吵。不過輔導室很安靜。' },
          { t: '我們去喝杯可可吧。', reply: '可可……其實聽起來不錯。' },
        ],
      },
    ],
  },
};
